import React from 'react'

import Layout from '../components/layout'

import { graphql } from 'gatsby'

import SEO from '../components/seo'

import PropertyMagCards from '../components/property-mag-cards'

export default ({ data }) => {
    let page = data.allWordpressPage.edges[0].node

    return (
        <Layout
            breadcrumb={[
                { title: 'Home', link: '/' },
                { title: 'Property Mag' }
            ]}
            marketTicker
        >
            <SEO
                title={page.yoast_meta.yoast_wpseo_title}
                description={page.yoast_meta.yoast_wpseo_metadesc}
            />
            <div className="wrapper">
                <PropertyMagCards data={data} />
            </div>
        </Layout>
    )
}

export const query = graphql`
    {
        allWordpressWpPropertyMag {
            edges {
                node {
                    name
                    slug
                    acf {
                        mag_image {
                            localFile {
                                childImageSharp {
                                    fluid(maxWidth: 900) {
                                        ...GatsbyImageSharpFluid_withWebp
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        allWordpressPage(filter: { slug: { eq: "property-mag" } }) {
            edges {
                node {
                    yoast_meta {
                        yoast_wpseo_title
                        yoast_wpseo_metadesc
                    }
                }
            }
        }
    }
`
